
import { Injectable } from '@angular/core';

@Injectable()

export class EnvDataService {

    public EnvData:any

    constructor() {
        if(process.env.IONIC_ENV === 'dev') {

            const env = {
               sendbox_api: 'https://us-central1-sync-afy-dev-sandbox.cloudfunctions.net'
            //    sendbox_api:'https://us-central1-loan-management-sandbox.cloudfunctions.net'
           };
           this.EnvData = env;
       }
       else {
            const env = {
               sendbox_api: 'https://us-central1-sync-afy-dev-sandbox.cloudfunctions.net'
            //    sendbox_api:'https://us-central1-loan-management-sandbox.cloudfunctions.net'
           };
           this.EnvData = env;
       }
    }


}


// WEBPACK FOOTER //
// ./src/app/services/env-data-service.ts